module.exports = __webpack_public_path__ + "media/kalendarium_color.4dd25f36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kalendarium_color.svg
// module id = 498
// module chunks = 0